import React, { useState } from "react";
import Input from "../../components/input";
import Button from "../../components/button";
import { changePassword } from "../../api/endpoint";
import { useSelector } from "react-redux";
import axios from "axios";
import toast from "react-hot-toast";
import Loader from "../../components/loader";

const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);
  const { auth } = useSelector((state) => state.login);

  const validateFields = () => {
    let newErrors = {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    };
    if (!oldPassword) newErrors.oldPassword = "Old Password is Required.";
    if (!newPassword) {
      newErrors.newPassword = "New Password is Required.";
    }
    if (!confirmPassword) {
      newErrors.confirmPassword = "Password Confirmation is Required";
    }
    setErrors(newErrors);
    return (
      !newErrors.oldPassword &&
      !newErrors.newPassword &&
      !newErrors.confirmPassword
    );
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (validateFields() == false) return;
    const payload = {
      oldPassword,
      newPassword,
      confirmPassword,
    };
    try {
      setLoading(true)
      const response = await axios.put(changePassword, payload, {
        headers: {
          Authorization: `Bearer ${auth}`,
        },
      });
      toast.success("Password Change Successful")
      setOldPassword("")
      setNewPassword("")
      setConfirmPassword("")
    } catch (error) {
      toast.error("Error Changing Password")
      console.error("Error Changing Password", error)
    } finally {
      setLoading(false)
    }
  };

  return (
    <>
      {loading && <Loader />}
      <div className="px-md-2 px-1 py-md-2 py-1">
        <h2>Change Password</h2>
        <div className="mt-4">
          <form style={{ maxWidth: "500px" }}>
            <div className="mb-2">
              <Input
                label="Old Password"
                type="password"
                placeholder="Enter Old Password"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
              />
              {errors?.oldPassword && (
                <div className="text-danger">{errors?.oldPassword}</div>
              )}
            </div>
            <div className="mb-2">
              <Input
                label="New Password"
                placeholder="Enter New Password"
                type="text"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              {errors?.newPassword && (
                <div className="text-danger">{errors?.newPassword}</div>
              )}
            </div>
            <div className="mb-2">
              <Input
                label="Confirm New Password"
                placeholder="Confirm New Password"
                type="text"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              {errors?.confirmPassword && (
                <div className="text-danger">{errors?.confirmPassword}</div>
              )}
            </div>
            <Button
              text="Change Password"
              callBack={(e) => handleChangePassword(e)}
              className="mt-3"
            />
          </form>
        </div>
      </div>
    </>
  );
};

export default ChangePassword;
